<template>
  <div class="d-flex flex-1-1 fd-column fd-row:w">
    <div>
      <top-pro-section v-if="showTopPro" :isTopPro="isTopPro"/>
      <div class="PANEL m-r-1">
        <div class="p-x-3 p-y-2 p-1:mo">
          <div class="TITLE">
            <h3 class=" d-flex flex-1-1 fd-column m-r-6:w" >
              90 Day Summary Report
            </h3>
          </div>
          <div class="m-b-2">
            <buttons :buttons="summaryButtons" @on-index-select="onButtonSelect"/>
          </div>
          <div class="MESSAGE">
            <div class="SUMMARY-TEXT">
              {{summaryMessage}}
            </div>
            <div class="SUMMARY-NUMBER">
              {{summaryNumber}}
            </div>
          </div>
        </div>
        <div class="d-flex CHART-CONTAINER">
          <div class="TARGET DASH-UNDER" v-if="showLeadsChart">Target:&#10;80%
          </div>
          <div
              class="SCROLL-WRAPPER p-b-2:mo"
              @scroll="handleScroll"
              :class="{'w-100': !this.$device.isMobile }">
            <div
                v-if="this.$device.isMobile && !showLeadsChart"
                class="d-flex fd-column-reverse ai-center"
                :class="{'LINEAR-GRADIENT LEFT': showLeftArrow,}">
              <vk-icon
                  v-if="showLeftArrow"
                  size="14"
                  name="chevronleft"
                  class="c-depot"/>
            </div>
            <div
                v-if="this.$device.isMobile && !showLeadsChart"
                class="d-flex fd-column-reverse ai-center"
                :class="{'LINEAR-GRADIENT RIGHT': showRightArrow,}">
              <vk-icon
                  v-if="showRightArrow"
                  size="14"
                  name="chevronright"
                  class="c-depot" />
            </div>
            <div class="CHART" :style="chartWidth">
              <apexchart
                  v-if="!isloading"
                  ref="summaryChart"
                  width="100%"
                  height="100%"
                  :options="chartOptions"
                  :series="series">
              </apexchart>
            </div>
          </div>
        </div>
        <div class="LEADS-CONTAINER p-y-2">
          <div>
            New Leads
            <div class="LEAD-NUMBER">{{ninetyDays.total_leads}}</div>
          </div>
          <div v-if="showLeadsChart">
            Contacted Leads
            <div class="LEAD-NUMBER">{{ninetyDays.leads_contacted}}</div>
          </div>
          <div v-else>
            Completed Jobs
            <div class="LEAD-NUMBER">{{ninetyDays.leads_completed}}</div>
          </div>

          <div v-if="showLeadsChart">
            Passed Leads
            <div class="LEAD-NUMBER">{{ninetyDays.leads_passed}}</div>
          </div>
          <div v-else>
            Hired Jobs
            <div class="LEAD-NUMBER">{{ninetyDays.leads_hired}}</div>
          </div>
          <div v-if="showLeadsChart">
            Avg. response time
            <div class="LEAD-NUMBER">{{averageContactTime}}</div>
          </div>
          <div v-else>
            Customer Reviews
            <div class="LEAD-NUMBER">{{totalReviews}}</div>
          </div>

        </div>
        <div v-html="formula" @click="handleClick" class="FORMULA">
        </div>
        <div v-if="showPerformanceFloorContent" class="PERFORMANCE-FLOOR m-x-3 m-b-3 p-3">
          <div class="PERFORMANCE-FLOOR-TITLE">Performance Floor: 20%</div>
          <div>
            Consistent Response Rate below the 20% performance floor may
            reduce the number of leads you receive and can lead to temporary
            suspension from the platform. Maintain a response rate above the
            floor to ensure consistent access to leads and avoid penalties.
            <a
                href="https://thdserviceprovider.my.site.com/prohelpcenter/s/article/Your-lead-response-rate?login=true"
                target="_blank"
                rel="noopener noreferrer">
              Learn more about performance requirements
            </a>
          </div>
        </div>
        <div class="d-flex jc-center p-b-4">
          <router-link
              @click.native="historyButtonClick"
              :to="{
                name: 'dashboard::pro::performance',
                params: {
                  activePerformanceTab: 'history',
                },
              }"
              class="btn-secondary p-x-5">
            View Full Data History
          </router-link>
        </div>
      </div>
    </div>
    <div class="PANEL d-flex fd-column  p-t-2 ">
      <div class="TITLE p-x-3">
        <h3>
          Action Items
        </h3>
      </div>
      <div class="w-100 ACTION-ITEMS-LIST">
        <action-items-list
            v-if="!isloading"
            :ninetyDays="ninetyDays"
            :totalReviews="totalReviews"
            :pointsBalance="pointsBalance"
            :isTopPro="isTopPro"
            :averageRating="averageRating"
            :watchedVideos="watchedVideos"/>
      </div>
    </div>
  </div>
</template>
<script>
import { subWeeks, subDays, format, isWithinInterval, getDay } from 'date-fns';
import http from '@homeservices/api-kit/axios';
import { mapGetters, mapActions } from 'vuex';
import VueApexCharts from 'vue-apexcharts';
import { SUMMARY_SECTIONS, CHART_OPTIONS } from '@/constants/summary-sections';
import Buttons from '../PerformanceButtons';
import ActionItemsList from './components/ActionItemsList';
import TopProSection from './components/TopProSection';


export default {
  SUMMARY_SECTIONS,
  CHART_OPTIONS,
  name: 'performance-summary',
  components: {
    Buttons,
    apexchart: VueApexCharts,
    ActionItemsList,
    TopProSection,

  },
  data () {
    return {
      SUMMARY_SECTIONS: this.$options.SUMMARY_SECTIONS(
        this.$runtimeConstants.SALESFORCE_ACCOUNT_REDIRECT_DOMAIN),
      isTopPro: null,
      isloading: false,
      hasLoaded: false,
      activeIndex: 0,
      thirtyDays: {},
      sixtyDays: {},
      ninetyDays: {
        total_leads: 0,
        leads_contacted: 0,
        leads_completed: 0,
        leads_passed: 0,
        leads_hired: 0,
        acceptance_rate: 0,
        avg_contact_time: 0,
        response_rate: 0,
        no_data: true,
      },
      weeksCompletedJobs: [],
      completedJobs: {},
      totalReviews: 0,
      pointsBalance: 0,
      averageRating: 0,
      scrollX: -360,
    };
  },
  computed: {
    ...mapGetters('user', [
      'userId',
    ]),
    ...mapGetters('account/pro/info', [
      'serviceProviderId',
    ]),
    ...mapGetters('account/pro/education', [
      'videoRecords',
    ]),
    chartWidth () {
      const newWidth = this.activeIndex === 2 && this.$device.isMobile ? '720px' : '100%';
      return { '--width': newWidth };
    },
    showLeftArrow () {
      return this.scrollX < -15;
    },
    showRightArrow () {
      return this.scrollX > -299;
    },
    chartOptions () {
      const options = this.showLeadsChart
        ? { ...this.$options.CHART_OPTIONS.leads(
          this.barColors,
          this.barData,
          this.offsets,
          this.showPerformanceFloorContent
        ) }
        : { ...this.$options.CHART_OPTIONS.completed(
          this.barColors, this.weeksCompletedJobs.map(week => format(new Date(week), 'MMM dd')), this.jobsCompletedPerWeek) };
      return options;
    },
    offsets () {
      if (!this.barDataNoZeroes) { return 0; }
      const dataLabelOffsets = this.barDataNoZeroes[0].data.map(val => (val > 20 ? 10 : -20));
      return dataLabelOffsets;
    },
    summaryButtons () {
      return (this.SUMMARY_SECTIONS.map((section) => {
        return { label: section.label };
      }));
    },
    averageContactTime () {
      if (this.hasLoaded) {
        const time = this.ninetyDays.avg_contact_time;
        return time === 1 ? `${time} hour` : `${time} hours`;
      }
    },
    summaryMessage () {
      return this.SUMMARY_SECTIONS[this.activeIndex].message;
    },
    summaryNumber () {
      if (this.hasLoaded) {
        switch (this.activeIndex) {
          case 1:
            return `${this.ninetyDays.acceptance_rate}%`;
          case 2:
            return this.ninetyDays.leads_completed;
          default:
            return `${this.ninetyDays.response_rate}%`;
        }
      }
      return 0;
    },
    series () {
      return this.showLeadsChart ? this.barDataNoZeroes : this.jobsCompletedPerWeek;
    },
    barColors () {
      if (this.series) {
        const bars = this.series[0].data.map((_, index) => {
          return (this.showLeadsChart && index === 0)
            || (!this.showLeadsChart && index === this.series[0].data.length - 2)
            ? '#F96302'
            : '#82ABB6';
        });
        return bars;
      }
    },
    jobsCompletedPerWeek () {
      if (this.weeksCompletedJobs && this.hasLoaded) {
        const jobDates = Object.entries(this.completedJobs)
          .filter(([key]) => key !== 'completed')
          .map(item => format(new Date(item[1].time_completed), 'MMM dd yy'));

        const completedJobsData = this.weeksCompletedJobs.map((item, index, arr) => {
          return jobDates.reduce((acc, cur) => {
            let jobs = acc;
            if (arr[index + 1]) {
              const end = arr[index + 2]
                ? subDays(new Date(arr[index + 1]), 1)
                : new Date(arr[index + 1]);
              jobs += isWithinInterval(
                new Date(cur),
                { start: new Date(item), end: new Date(end) }
              );
            } else {
              jobs = undefined;
            }
            return jobs;
          }, 0);
        });
        completedJobsData.splice(-1, 1, undefined);
        return [{ data: completedJobsData }];
      }
    },
    formula () {
      return this.SUMMARY_SECTIONS[this.activeIndex].formulaMessage;
    },
    barData () {
      if (this.hasLoaded) {
        const rate = this.activeIndex === 0 ? 'response_rate' : 'acceptance_rate';
        const series = { name: 'barValues', data: [this.ninetyDays[rate] || 0, this.sixtyDays[rate] || 0, this.thirtyDays[rate] || 0] };
        return series;
      }
    },
    barDataNoZeroes () {
      if (this.hasLoaded) {
        const NO_VALUE_MIN_WIDTH = 3;
        const series = { name: 'barDisplay', data: this.barData.data.map(value => (!value ? NO_VALUE_MIN_WIDTH : value)) };
        return [series];
      }
    },
    showLeadsChart () {
      return this.activeIndex < 2;
    },
    showTopPro () {
      return this.isTopPro !== null && this.hasLoaded;
    },
    watchedVideos () {
      return this.videoRecords.length;
    },
    showPerformanceFloorContent () {
      return this.activeIndex === 0;
    },
  },
  created () {
    this.getDates();
    this.fetchPerformanceInformation();
  },
  mounted () {
    this.getCompletedJobs(0);
    this.getRecords();
  },

  methods: {
    ...mapActions('dashboard/workOrderMatches', [
      'fetchWorkOrderMatches',
    ]),
    ...mapActions('account/pro/education', ['fetchVideoRecords']),
    async getCompletedJobs (fromVal) {
      const { total, entities } = await this.fetchWorkOrderMatches({
        params: {
          start_date: format(subDays(new Date(), 90), 'yyyy-MM-dd'),
          end_date: format(new Date(), 'yyyy-MM-dd'),
          statuses: 'completed',
          from: fromVal,
          service_provider_id: this.serviceProviderId,
        },
      });
      this.completedJobs = { ...this.completedJobs, ...entities.proWorkOrdersMatches };
      if (Object.keys(this.completedJobs).length < total) {
        this.getCompletedJobs(Object.keys(this.completedJobs).length);
      }
    },
    getDates () {
      const now = new Date();
      const lastSunday = subDays(now, getDay(now));
      const ninetyDaysAgo = subDays(now, 90);

      this.weeksCompletedJobs.unshift(format(now, 'MMM dd yy'));
      if (getDay(now) !== 0) {
        this.weeksCompletedJobs.unshift(format(lastSunday, 'MMM dd yy'));
      }
      this.weekCounter(ninetyDaysAgo, lastSunday);
    },
    weekCounter (start, end) {
      const theNextSunday = subWeeks(end, 1);
      if (isWithinInterval(theNextSunday, { start, end })) {
        this.weeksCompletedJobs.unshift(format(theNextSunday, 'MMM dd yy'));
        this.weekCounter(start, theNextSunday);
      } else if (getDay(start) !== 0) {
        this.weeksCompletedJobs.unshift(format(start, 'MMM dd yy'));
      }
    },
    async fetchPerformanceInformation () {
      this.isloading = true;
      try {
        const { data: { results: [result] } } = await http.get('/platform/coresearch/api/performance/v1', {
          params: {
            account_id: this.userId,
            is_time_interval: true,
          },
        });
        this.isTopPro = result.top_pro;
        if (result.leads_metrics['90_days_time_interval_leads']) {
          this.pointsBalance = result.points_balance || 0;
          this.averageRating = result.reviews_metrics['90_days_time_interval_reviews'].average_rating || 0;
          this.totalReviews = result.reviews_metrics['90_days_time_interval_reviews'].total_reviews || 0;
          this.thirtyDays = result.leads_metrics['30_days_time_interval_leads'] || {};
          this.sixtyDays = result.leads_metrics['60_days_time_interval_leads'] || {};
          this.ninetyDays = result.leads_metrics['90_days_time_interval_leads'];
        }
      } catch (e) {
        console.error(e); // eslint-disable-line no-console
      }
      this.isloading = false;
      this.hasLoaded = true;
    },
    historyButtonClick () {
      this.$events.$emit(
        this.$events.VIEW_HISTORY_FROM_SUMMARY,
        { origin: this.SUMMARY_SECTIONS[this.activeIndex].tabName }
      );
    },
    onButtonSelect (index) {
      this.activeIndex = index;
      this.$events.$emit(this.$events[this.SUMMARY_SECTIONS[index].eventName]);
    },
    handleClick (event) {
      this.$events.$emit(this.$events.URL_CLICK, { toURL: event.target.href });
    },
    handleScroll () {
      this.scrollX = document.getElementById('apexchartssummary').getBoundingClientRect().x;
    },
    getRecords () {
      this.fetchVideoRecords({ serviceProviderId: this.serviceProviderId });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";
  .ACTION-ITEMS-LIST{
    overflow-x: auto;
  }

  .TITLE {
    display: flex;
    margin-bottom: 2*$unit;
    h3 {
      margin: 0;
    }
  }
  .PANEL {
    position: relative;
    background-color: white;
    border: solid;
    border: 1px solid #CCCCCC;
    border-radius: 4px;
    margin-bottom: 2 * $unit;
    height: 120 * $unit;
    max-width: 97 * $unit;
    @include mobile-only {
          height: 110 * $unit;
    }
    @include responsive(
      flex,
      0 0 35%,
    );
    &:first-of-type {
      @include wide {
        margin-right: $unit;
        flex: 1 0 65%
      }
    }
  }
  .MESSAGE {
     @include desktop {
        border-bottom: solid 1px $color-gray40;
      }
  }
  .SUMMARY-TEXT {
    font-size: 16px;
      @include mobile-only {
        font-size: 14px;
      }
  }
  .SUMMARY-NUMBER {
    font-size: 22px;
  }
  .LEAD-NUMBER {
    font-size: 24px;
  }
  .CHART-CONTAINER{
    position: relative;
    @include  desktop {
      margin: 0 (3*$unit);
    }
    @include mobile-only {
      width: 95vw;
    }
  }
  .CHART {
    position: relative;
    z-index: 2;
    height : 200px;
    width: var(--width);
  }
  .LINEAR-GRADIENT {
    z-index: 25;
    position:absolute;
    height: 210px;
    width: 20px;
    text-align: center;
    &.LEFT {
      left:0px;
      background-image: linear-gradient(to right, white, transparent);
    }
    &.RIGHT {
      right:0px;
      background-image: linear-gradient(to left, white, transparent);
    }
  }
  .SCROLL-WRAPPER {
    height: 100%;
    width: 100%;

    @include mobile-only {
    overflow-x: auto;
    direction: rtl;
    overflow-y: hidden;
    }
  }
  .TARGET {
    position: absolute;
    z-index: 1;
    left:0px;
    background-color: #d1e6d9;
    white-space: pre-wrap;
    text-align: left;
    font-size:  12px;
    padding-left: 4px;
    padding-top: 1px;
    height:34px;
    width:100%;
    line-height: 15px;
  }
  .DASH-UNDER::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    border-bottom: 1px dashed $color-gray80;
  }
  .LEADS-CONTAINER {
    width: 100%;
    max-height: 200px;
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    justify-content: space-between;
    background-color: $color-gray20;
    @include tablet {
      padding: (2*$unit) (4*$unit);
    }
    @include mobile-only {
      flex-direction: column;
    }
  }
  .FORMULA {
    font-size:  14px;
    padding: 16px 12px;
    @include desktop {
      padding: 16px 40px;
    }
  }
  .PERFORMANCE-FLOOR {
    border: 1px solid #e69595;
    border-radius: 4px;
    color: #4a4a4a;
    font-size: 13px;
    line-height: 1.4;
  }
  .PERFORMANCE-FLOOR-TITLE {
    color: #333333;
    font-weight: 700;
    margin-bottom: $unit;
  }
  /deep/.FORMULA a ,/deep/.ACTION-ITEMS-LIST a{
    text-decoration: underline;
    color:#286FAD;
  }
  /deep/.PERFORMANCE-FLOOR a {
    color: #d22630;
    text-decoration: underline;
    font-weight: 600;
  }
</style>
